// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2w0bX","large":"styles_large__G_D_L"};